import { ModalBody } from '@stenajs-webui/modal';
import { useCallback, useState } from 'react';
import { useAppNavigate } from '../../../../../common/hooks/useAppNavigate';
import { modalRouteCreators } from '../../../../../common/routes/AppRoutes';
import {
  type InformationMessage,
  InformationMessageType,
} from '../../../../../common-ui/information-message/informationMessageUtils';
import { AutoCancellationInfoBanner } from '../AutoCancellationInfoBanner';
import { BookingDetailsHeader } from '../BookingDetailsHeader';
import type { BookingDetailsResultProps } from '../BookingDetailsModalLoader';
import { BookingDetailsEditBookingActions } from './BookingDetailsEditBookingActions';
import { BookingDetailsEditContent } from './BookingDetailsEditContent';
import { BookingDetailsEditFooter } from './BookingDetailsEditFooter';

export interface BookingDetailsEditContainerProps extends BookingDetailsResultProps {}

export const BookingDetailsEditContainer = ({
  onRequestClose,
  booking,
}: BookingDetailsEditContainerProps) => {
  const { replace } = useAppNavigate();
  const { bookingNo } = booking;

  const [statusMessages, setStatusMessages] = useState<InformationMessage[]>([]);

  const onCancelFail = useCallback(() => {
    setStatusMessages([
      {
        message: `Failed to cancel booking (${bookingNo})`,
        type: InformationMessageType.HardWarning,
      },
    ]);
  }, [bookingNo, setStatusMessages]);

  const navigateToView = useCallback(() => {
    setStatusMessages([]);
    replace(modalRouteCreators.bookingDetailsView({ bookingNo }));
  }, [bookingNo, replace]);

  return (
    <>
      <ModalBody maxWidth={1408}>
        <BookingDetailsHeader
          className={'t_booking_details_edit_header'}
          booking={booking}
          onRequestClose={onRequestClose}
          bookingActions={<BookingDetailsEditBookingActions booking={booking} />}
        />
        <BookingDetailsEditContent bookingNo={bookingNo} onStopEdit={navigateToView}>
          <AutoCancellationInfoBanner info={booking.autoCancellation} />
        </BookingDetailsEditContent>
      </ModalBody>
      <BookingDetailsEditFooter
        booking={booking}
        onCancelFail={onCancelFail}
        statusInformationList={statusMessages}
      />
    </>
  );
};
